import logo from "../logo.png";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const menu = `${process.env.PUBLIC_URL}/img/menu.svg`;

const Navbar = () => {
  const [sideBarOpen, setSideBarOpen] = useState(false);
  const menuBarRef = useRef();

  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/login");
  };

  useEffect(() => {
    const handler = (event) => {
      if (menuBarRef.current && !menuBarRef.current.contains(event.target)) {
        setSideBarOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  return (
    <header ref={menuBarRef} className="fixed w-full bg-white z-50 shadow-lg">
      <div className="flex justify-between items-center h-24 w-full xl:max-w-7xl mx-auto px-10 shadow-sm">
        <a href="#" className="flex gap-2 items-center cursor-pointer">
          <img src={logo} className="h-10" alt="logo" />
          <p className="font-black">WHISTLEBLOWER</p>
        </a>

        <nav className="hidden sm:inline-flex gap-4 items-center font-black">
          <a href="#" className="hover:text-primary">
            Home
          </a>
          <a href="#AboutUs" className="hover:text-primary">
            About Us
          </a>
          <a href="#ContactUs" className="hover:text-primary">
            Contact Us
          </a>
          <button
            href="#"
            className="cursor-pointer px-3 py-1 rounded-3xl text-white bg-primary hover:text-gray-100 hover:bg-secondary"
            onClick={handleLoginClick}
          >
            Login
          </button>
        </nav>

        <button
          className="sm:hidden"
          onClick={() => setSideBarOpen(!sideBarOpen)}
        >
          <img src={menu} className="h-10 cursor-pointer" alt="menu" />
        </button>
      </div>

      {sideBarOpen && (
        <div className="flex justify-start rounded-xl py-4 mx-10 px-10 text-2xl sm:hidden">
          <nav className="flex flex-col button_div gap-4">
            <a
              href="#"
              className="hover:text-primary"
              onClick={() => setSideBarOpen(!sideBarOpen)}
            >
              Home
            </a>
            <a
              href="#AboutUs"
              className="hover:text-primary"
              onClick={() => setSideBarOpen(!sideBarOpen)}
            >
              About Us
            </a>
            <a
              href="#ContactUs"
              className="hover:text-primary"
              onClick={() => setSideBarOpen(!sideBarOpen)}
            >
              Contact Us
            </a>
            <button
              href="#"
              className="cursor-pointer px-3 py-1 w-24 rounded-3xl text-white bg-primary hover:text-gray-100 hover:bg-secondary"
              onClick={handleLoginClick}
            >
              Login
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
